import { Component, OnInit, OnDestroy, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { printableStyles } from '../../../utils'
import { NotificationService } from '../../../services'
import QRCode from 'qrcode'
import { ProductDetailService } from '../../../product-detail.service'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'qrcode-print',
  templateUrl: 'qrcode-print.component.html',
  styleUrls: ['qrcode-print.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class QrcodePrintComponent implements OnInit, OnDestroy {
  @ViewChild('barcode', { static: true }) barcode: ElementRef
  @ViewChild('printable') printableEl: ElementRef
  @ViewChild('qr') qrEl: ElementRef
  ean: string
  batch: string
  expirationDate: string
  numberOfCopies = 1
  qrBase64 = ''
  finalCode = ''
  paramsCheckInterval = null
  isInDesktopApp = false
  isPrinting = false

  constructor(
    private notificationService: NotificationService,
    private productDetailService: ProductDetailService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    if (this.productDetailService.product.ean?.length > 0) {
      this.ean = this.productDetailService.product.ean
    }
    this.generateQR()
    this.paramsCheckInterval = setInterval(() => {
      if (window['dataQR']) {
        this.generateQR()
      }
    }, 500)
    setTimeout(() => (this.isInDesktopApp = !!window._depoto), 1000)
  }

  ngOnDestroy() {
    if (this.paramsCheckInterval) {
      clearInterval(this.paramsCheckInterval)
    }
  }

  async generateQR() {
    if (!this.ean || this.ean.length === 0) {
      console.warn('Barcode null')
      this.notificationService.error(this.translateService.instant('qrcode.no-ean'))
      return
    }
    if (window['dataQR'] && window['dataQR'].batch) {
      this.batch = window['dataQR'].batch
    }
    if (window['dataQR'] && window['dataQR'].expirationDate) {
      this.expirationDate = window['dataQR'].expirationDate
    }
    if (window['dataQR']) {
      window['dataQR'] = undefined
    }
    try {
      const padZero = (s: string, len: number) => {
        return s.length === len ? s : padZero(`0${s}`, len)
      }
      const ean = this.ean.length === 14 ? this.ean : padZero(this.ean, 14)
      const expDate =
        this.expirationDate?.length >= 10
          ? `${this.expirationDate[2]}${this.expirationDate[3]}${this.expirationDate[5]}${this.expirationDate[6]}${this.expirationDate[8]}${this.expirationDate[9]}`
          : null
      this.finalCode = `${this.ean}`
      if ((this.batch && this.batch.length > 0) || (this.expirationDate && this.expirationDate.length > 0)) {
        this.finalCode = `(01)${ean}${expDate?.length ? `(17)${expDate}` : ''}${
          this.batch?.length ? `(10)${this.batch}` : ''
        }`
      }
      this.qrBase64 = await QRCode.toDataURL(this.finalCode.split('(').join('').split(')').join(''))
    } catch (err) {
      this.notificationService.error(this.translateService.instant('qrcode.no-ean'))
      console.error(err)
    }
  }

  async printQR() {
    this.isPrinting = true
    if (window._depoto) {
      for (let i = 0; i < this.numberOfCopies; i++) {
        setTimeout(() => {
          window._depoto.node.printLPImage(this.qrBase64, null, window._depoto.paperSize.custom60x60mm)
          if (i === this.numberOfCopies - 1) {
            this.isPrinting = false
          }
        }, i * 2500)
      }
    } else {
      this.confirmPreview()
      this.isPrinting = false
    }
  }

  confirmPreview(): void {
    const pWidth = 900
    const pHeight = 720
    const popupWin = window.open(
      '',
      'Tisk štítků',
      `toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${pWidth},height=${pHeight},top=${
        screen.height - (screen.height + pHeight) / 2
      },left=${screen.width - (screen.width + pWidth) / 2}`
    )
    popupWin.document.body.innerHTML = this.printableEl.nativeElement.innerHTML
    const styles = document.createElement('style')
    styles.innerHTML = printableStyles()
    popupWin.document.head.appendChild(styles)
    popupWin.print()
    setTimeout(() => {
      popupWin.close()
    }, 100)
  }
}
